import { create } from 'zustand';
import { activityService } from '../services/api';
import { applyBrandTheme, DEFAULT_THEME } from '../utils/theme';

// School name/logo, admin-editable (AdminSchoolSettings.js). Fetched once
// and cached for the session — Logo.js renders on nearly every page, and
// the branding endpoint is public precisely so the logged-out login screen
// can use it too, so this avoids refetching it on every mount.
const useBrandingStore = create((set, get) => ({
  siteName: null,
  logo: null,
  socialLinks: {},
  primaryColor: DEFAULT_THEME.primary_color,
  sidebarColor: DEFAULT_THEME.sidebar_color,
  celebrationEnabled: false,
  loaded: false,
  loading: false,

  load: () => {
    if (get().loaded || get().loading) return;
    set({ loading: true });
    activityService.getBranding()
      .then((res) => {
        applyBrandTheme(res.data);
        set({
          siteName: res.data.site_name,
          logo: res.data.logo,
          socialLinks: res.data.social_links || {},
          primaryColor: res.data.primary_color || DEFAULT_THEME.primary_color,
          sidebarColor: res.data.sidebar_color || DEFAULT_THEME.sidebar_color,
          celebrationEnabled: Boolean(res.data.landing_celebration_enabled),
          loaded: true,
          loading: false,
        });
      })
      .catch(() => set({ loaded: true, loading: false }));
  },
  setBranding: (data) => {
    applyBrandTheme(data);
    set({
      siteName: data.site_name,
      logo: data.logo,
      socialLinks: data.social_links || {},
      primaryColor: data.primary_color || DEFAULT_THEME.primary_color,
      sidebarColor: data.sidebar_color || DEFAULT_THEME.sidebar_color,
      celebrationEnabled: Boolean(data.landing_celebration_enabled),
      loaded: true,
      loading: false,
    });
  },
}));

export default useBrandingStore;
